import api from 'api/apiInstance';

export function userOAuthAccounts(path: string) {
  return {
    path,
    GET: () => api.get(path),
    SIGN_OUT: (oauthAccountId: number) => api.post(`${path}/${oauthAccountId}/sign_out`),
  };
}
